import _round from 'lodash/round';
// Serialization
import { deserialize } from 'serializr';
import { priceRuleSchema } from './schemas';
// Fragments
import { priceRuleFragment } from './fragments';
// Custom
import { SEARCHFIELD_TYPES } from '../../constants/App';

/**
* Serialization
*/
const deserializePriceRule = (data) => deserialize(priceRuleSchema, data);

/**
* GraphQL
*/
const queListPriceRules = `
  query ListPriceRules($search: ListPriceRulesSearchInput) {
    listPriceRules(search: $search) {
      ...priceRuleFragment
    }
  }

  ${priceRuleFragment}
`;

/**
* Utils
*/
const getPriceRuleCountryFilter = (country) => ({
  field: 'country',
  operator: SEARCHFIELD_TYPES.string.defaultOperator('eq'),
  value: country,
});

// For the 2 following methods: use a flat 100 for the moment
// This value may change in the future according to price rule
const priceRuleDisplayAmount = (amount/* , priceRule */) => amount / 100;
const priceRuleSerializeAmount = (amount/* , priceRule */) => _round(amount * 100);

/**
* Model
*/
const priceRule = {
  // Name
  name: 'priceRule',

  // Serialization
  deserialize: deserializePriceRule,

  // Utils
  getCountryFilter: getPriceRuleCountryFilter,
  displayAmount: priceRuleDisplayAmount,
  serializeAmount: priceRuleSerializeAmount,

  // GraphQL
  queListPriceRules,
};

module.exports = priceRule;



// WEBPACK FOOTER //
// ./models/cpm/priceRule.js